import { roundNumber } from "src/utils/genericFunctions";
import { HeaderRule } from "../../interface";
import HighlightValue from "./highlightValue";
import { Box } from "@mui/material";
import InputPMR from "./InputPMR";
import theme from "src/themes";

const idMapper = {} as any;

for (let i = 0; i <= 6; i++) {
  idMapper[`${i}-order`] = {
    top: `${i}-order`,
    bottom: `${i}-received`
  };
}

export const DisplayWithInput = (headerItem: HeaderRule, rowData: any) => {
  const topValue =
    rowData[idMapper[headerItem?.id]?.top] === null
      ? "-"
      : roundNumber(rowData[idMapper[headerItem?.id]?.top], 0, 0);
  const bottomValue =
    rowData[idMapper[headerItem?.id]?.bottom] === null
      ? "-"
      : roundNumber(rowData[idMapper[headerItem?.id]?.bottom], 0, 0);
  return (
    <Box display="flex" flexDirection="column" gap="4px">
      <HighlightValue
        value={topValue.toString()}
        color={theme.palette.extended.olive}
        backgroundColor={theme.palette.extended.tanYellow}
      />

      {headerItem?.editMode ? (
        <InputPMR
          rowData={rowData}
          id={idMapper[headerItem?.id]?.bottom}
          itemId={rowData?.itemId}
          editMode={headerItem?.editMode}
          onBlur={(id: string, itemId: string | number, value: any) => {
            headerItem?.handleBlur(id + "-bottom", itemId, value);
          }}
          disabled={rowData?.inputDisabled?.[headerItem?.id]}
          disableDecimalDigit={true}
          sxConfig={{
            "& .MuiOutlinedInput-input": {
              padding: "4px"
            },
            height: "34px",
            width: "100%",
            fontSize: "14px"
          }}
        />
      ) : (
        <HighlightValue
          value={bottomValue.toString()}
          color={theme.palette.extended.olive}
          backgroundColor={theme.palette.extended.tanYellow}
        />
      )}
    </Box>
  );
};
